/**
 * Query keys del dominio del Optimizador de Cortes.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). El
 * historial se filtra por la sede activa (el backend lo hace vía `X-Sede-Id`), así que
 * cada key incluye la sede para **cachear por sede**: al cambiar de sede, el historial
 * se recarga (clave distinta) en vez de mostrar el de la sede anterior. El listado
 * incluye el `limit`; el detalle, el id del job.
 */

/** Raíz de todas las queries de cutlist (para invalidación amplia tras guardar). */
export const CUTLIST_ROOT_KEY = ["cutlist"] as const;

/** Key del historial de jobs, segmentada por sede y límite. */
export function cutlistJobsQueryKey(sedeId: number | null, limit: number) {
  return ["cutlist", "jobs", { sede: sedeId, limit }] as const;
}

/** Key de un job concreto, segmentada por sede e id. */
export function cutlistJobQueryKey(sedeId: number | null, jobId: number) {
  return ["cutlist", "job", { sede: sedeId, id: jobId }] as const;
}
